<template>
<div class="chapter">
<div class="inner_page">
<div><a id="c1"></a></div>
<div class="xpage">
<h4 class="chaptitle"><a href="#/html/003_toc#c1_">ON ABORTION</a></h4>
<p class="textfirst">I think the Democrats historically have made a mistake just trying to avoid the issue or pretend that there’s not a moral component to it. There is. I am pro-choice,
    but I also think that it’s important—even as I indicate that I’m pro-choice—to say this is not a trivial issue. And we have to listen to the profound concerns that other
    people have.</p>
<p class="right2"><em>Face the Nation</em>, March 12, 2006</p>
</div>
<div class="xpage">
<p class="textfirst2">No one is pro-abortion.</p>
<p class="right2">Speech at Benedictine University, October 5, 2004</p>
</div>
<div class="xpage">
<p class="textfirst2">I don’t know anybody who is pro-abortion. I think it’s very important to start with that premise. I think people recognize what a wrenching, difficult issue it
    is. Our goal should be to make abortion less common; that we should be discouraging unwanted pregnancies, that we should encourage adoption wherever possible.</p>
<p class="right2"><em>Christianity Today</em>, January 2008</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_chap1.vue?95071d1c